import React from 'react';

const About = () =>
    <div className="About">
        <div className="header">
            <h1>Hanad Hassan</h1>
        </div>
        <div className="about-content">
          <img src={require("../../img/profile_pic.jpg")} width="450" height="500"/>
          <p className="blurb">
              Hi, I'm Hanad, ^ thats me. <br/><br/> I like data science, all things machine learning and statistics.
              I am a third year statistics student at the University of Toronto hoping to focus on machine learning. Currently working at Prolora as a Software Engineer on IoT related applications.
              In my spare time, I enjoy spending time reading, watching eSports and programming.
          </p>
        </div>
          
    </div>

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/About.jsx